import { cn } from "~/lib/utils"; // Utility function to merge classNames

interface TextProps {
  className?: string;
  children: React.ReactNode;
}

export default function Text({
  className,
  children,
}: TextProps) {

  return (
    <span
      className={cn(
        className,
      )}
    >
      {children}
    </span>
  );
}
